/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer" | "PdpSharedBlurbDesignYourOwn_viewer" | "useShippingPrice_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$data = PdpRespSidebarBlurbs_viewer;
export type PdpRespSidebarBlurbs_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbDesignYourOwn_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '19fd2ba8fa0d3cc22f4838b62c2beaf5';
export default node;
